<script setup>
import { computed } from 'vue';
import { stripHtmlToPlainText } from '../../../shared/html-text.js';

const props = defineProps({
  label: { type: String, default: '' },
  clearHref: { type: String, default: '' }
});

const displayLabel = computed(() => stripHtmlToPlainText(props.label));
</script>

<template>
  <div class="vsb-cat-rental" role="status">
    <p class="vsb-cat-rental__title">
      <strong>Gekozen huurperiode:</strong> {{ displayLabel }}
    </p>
    <p class="vsb-cat-rental__hint">
      Hieronder ziet u het volledige aanbod in deze categorie. Beschikbaarheid per machine controleert u bij het reserveren.
    </p>
    <p v-if="clearHref" class="vsb-cat-rental__actions">
      <a :href="clearHref">Huurperiode wissen</a>
    </p>
  </div>
</template>

<style scoped>
.vsb-cat-rental {
  max-width: 1200px;
  margin: 0 auto 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid #b8d4f0;
  border-left: 4px solid #004494;
  background: #f0f6fc;
  border-radius: 6px;
  font-size: 0.95rem;
  line-height: 1.45;
  color: #1a1a1a;
}
.vsb-cat-rental__title {
  margin: 0 0 0.35rem;
}
.vsb-cat-rental__hint {
  margin: 0;
  color: #444;
}
.vsb-cat-rental__actions {
  margin: 0.5rem 0 0;
  font-size: 0.9rem;
}
.vsb-cat-rental__actions a {
  color: #004494;
}
</style>
